<script setup>
import { onBeforeUnmount, onMounted, reactive } from 'vue'
import MenuLayout from '../layout/MenuLayout.vue'
import { useMemberStore, useMetaStore } from '@/stores'
import { useRouter } from 'vue-router'
import { QuillEditor } from '@vueup/vue-quill'
import { down, ensureElement, get, isImage, isImgFile, isValidPassword, loadAuthImg, openWin, post, postMultipart, qsel, qsela, selectText, validators, ymd, ymdhm } from '@/common/util'
import _ from 'lodash-es'
import FileIcons from 'file-icons-vue'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import ConfirmCard from '@/components/ConfirmCard.vue'
import config from '@/common/config'
import { el } from 'vuetify/locale'
const baseUrl = import.meta.env.BASE_URL;
const meta=reactive({inqueryheads:[{tk:'title',col:'ttl'},{tk:'status',col:'stat'},{tk:'dateofenrollment',col:'cdt'}],component:null,apikeyreq:{apikey:null},myinfo:{},seltab:'managemynotes',tabs:['managemynotes']
    ,pdinq:{cont:'',category:'oneonone_inquery'},sinq:{page:1,size:20,where:{},sortcol:'cdt',isasc:false},inqueries:{rows:[]},inqheight:window.innerHeight-280,memos:[],memotblheight:400})
  ,memStore=useMemberStore(),router=useRouter(),metaStore=useMetaStore()
,logout=()=>{
  memStore.logout()
  router.push('/login')
},pop=(type,id)=>{
  meta.poptype=null
  if(type=='changeyouremail'){
    meta.emailtochange=null
    meta.verificationnumber=null
  }
  if(type=='withdrawal'){
    meta.myinfo.passwdforwithdrawal=''
  }
  if(type=='newinquery')selComponent('inquery')
  meta.pdinq={cont:'',category:'oneonone_inquery'}
  if(typeof(type)=='object')type=null
  if(type=='memodetail'){
      meta.selmemo=meta.memos.find(memo=>memo.id==id)
      ensureElement('.memodetail .memoimg',()=>{
        const memoimg=meta.memofiles.find(mf=>mf.refid==id)
        const img=qsel('.memodetail .memoimg')
        if(memoimg){
          img.src=config.backend+'attachedfile/'+memoimg.id
          img.parentElement.classList.remove('d-none')
        }else img.parentElement.classList.add('d-none')
      })
    }
  metaStore.pop({callback:()=>{
    meta.poptype=type
  },ison:type!=null,persist:false})
},changeEmail=async()=>{
  meta.poptype='changeyouremail_loading'
  const res=await post('rest/authed/member/updateemail',{mid:meta.myinfo.mid,authcode:meta.verificationnumber,email:meta.emailtochange})
  if(res.isSuccess){
    pop()
    metaStore.toastKey('email_changed')
    meta.myinfo.email=meta.emailtochange
  }
  else{
    meta.poptype='changeyouremail'
    metaStore.toastRslt(res)
  }
},sendCode=async()=>{
  meta.poptype='changeyouremail_loading'
  const res=await post('rest/authed/member/sendemailauthcode',{mid:meta.myinfo.mid,email:meta.emailtochange})
  if(res.isSuccess){
    meta.poptype='changeyouremail_sent'
    metaStore.toastKey('wehavesentaverificationnumbertotheemailyouprovided')
  }
  else{
    meta.poptype='changeyouremail'
    metaStore.toastRslt(res)
  }
},delInquery=id=>{
  metaStore.dialog({ttl:metaStore.t('del_lbl_conttl').replace('_lbl_',metaStore.t('inquiries')),cont:metaStore.t('del_con'),istk:false,onok:async()=>{
    const res=await post('rest/authed/member/delinquery',{id:id})
    metaStore.toastRslt(res,false)
    searchInquery()
  }})
},newInquery=async()=>{
  metaStore.blockLoading()
  const res=await postMultipart('rest/authed/member/newinquery',meta.pdinq)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  searchInquery()
},inqueryDetail=async(row)=>{
  metaStore.blockLoading()
  const pms={tartbl:'Inquery',rids:[row.id]}
  const resreplies=await post('rest/authed/member/inqueryreplies',pms.rids)
  const resfiles=await post('rest/authed/member/upfilepaths',pms)
  if(resfiles.data.length>0){
    row.fid=resfiles.data[0].id
    row.fn=resfiles.data[0].fn
    row.furl=`/rest/authed/member/attachedfile/${row.fid}`;
    if(isImage(resfiles.data[0].filepath))row.imgdata=await loadAuthImg(row.furl)
  }
  if(resreplies.data.length>0)row.reply=resreplies.data[0].cont
  metaStore.blockLoading(false)
  meta.selinquery=row
},withdraw=async()=>{
  metaStore.blockLoading()
  let res=await post('rest/authed/member/withdraw',{mid:meta.myinfo.mid,passwd:meta.myinfo.passwdforwithdrawal})
  metaStore.blockLoading(false)
  if(res.isSuccess){
    metaStore.toast('회원탈퇴가 완료되었습니다.',true)
    return logout()
  }
  metaStore.toastRslt(res,true)
},saveMyInfo=async()=>{
  meta.myinfo.etc=meta.confirmttlkey
  delete meta.myinfo.passwdcon
  metaStore.blockLoading()
  let res=await post('rest/authed/member/modmyinfo',meta.myinfo)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  res=await get('rest/authed/member/myinfo')
  meta.myinfo=res.data
},selComponent=async(component)=>{
  meta.component=null
  if(component=='inquery'){
    meta.selinquery=null
  }
  if(component=='myinfo'){
    metaStore.blockLoading()
    meta.myinfo=await get('rest/authed/member/myinfo')
    metaStore.blockLoading(false)
    meta.myinfo=meta.myinfo.data
  }
  meta.component=component
},fitInqheight=async()=>{
  meta.inqheight=window.innerHeight-280
},reqApikey=()=>{
  metaStore.blockLoading()
  setTimeout(async() => {
    const res=await post('rest/authed/member/reqapikey')
    meta.apikeyreq=res.data
    metaStore.blockLoading(false)
  }, 1000);
},searchMyApi=async()=>{
  get('rest/authed/member/getapikeyreq',res=>{
  meta.apikeyreq=res.data??{apikey:null}
})
},inqFileChange=file=>{
  if(!file)return
  if(!isImgFile(file.name)){
    qsel('.inqfile .mdi-close-circle').click()
    return metaStore.toastKey('notimgfile',false)
  }
  if(file.size/1024/1024>5){
    qsel('.inqfile .mdi-close-circle').click()
    return metaStore.toast('5MB 이상은 첨부 할 수 없습니다',false)
  }
},copyApikey=()=>{
  selectText('.apikey')
  document.execCommand('copy')
  metaStore.toastKey('copied')
},delMemoImg=async()=>{
  if(!confirm(metaStore.t('del_con')))return
  if(meta.selmemo?.id){
    const res=await post('rest/authed/member/delmemoimg',{id:meta.selmemo.id})
    metaStore.toastRslt(res,false)
  }
  meta.selmemo.file=null
  qsel('.memodetail .memoimgwrap').classList.add('d-none')
},delMemo=async(id)=>{
  if(!confirm(metaStore.t('del_con')))return
  metaStore.blockLoading()
  const res=await post('rest/authed/member/delmemo',{id:id})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,false)
  searchMemo(1)
},saveMemo=async()=>{
  const modmemo={...meta.memos.find(memo=>memo.id==meta.selmemo.id)}
  modmemo.ttl=meta.selmemo.ttl
  modmemo.cont=meta.selmemo.cont
  modmemo.xpos=meta.selmemo.xpos
  modmemo.ypos=meta.selmemo.ypos
  modmemo.addr=meta.selmemo.addr
  modmemo.file=meta.selmemo.file
  if(_.isEmpty(modmemo.ttl))return metaStore.toastKey('enteratitleupto50characters',false)
  if(!confirm(metaStore.t('save_con')))return
  metaStore.blockLoading()
  const res=await postMultipart('rest/authed/member/savememo',modmemo)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  searchMemo(1)
},searchMemo=async(page=1)=>{
  const pm={where:{ttl_or_:meta.memosearchval},page:page,size:20,sortcol:'mdt',isasc:false}
  pm.where.cont_or_=pm.where.ttl_or_
  const res=await post('rest/authed/member/searchmemo',pm)
  meta.memos=res.data.rows
  const files=await post(`rest/authed/member/attachedfiles`,{tartbl:'Memo',refids:meta.memos.map(memo=>memo.id)})
  meta.memofiles=files.data
  meta.memotblheight=window.innerHeight-600
  if(meta.memotblheight<400)meta.memotblheight=400
},searchInquery=async()=>{
  selComponent('inquery')
  meta.sinq.where.mid_eq_=memStore.mid
  metaStore.blockLoading()
  const res=await post('rest/authed/member/inqueries',meta.sinq)
  metaStore.blockLoading(false)
  meta.inqueries=res.data
},setIfrCont=(ifr,cont)=>{
  if(!cont)return
  const doc=ifr.contentDocument
  while (doc.head.firstChild)doc.head.removeChild(doc.head.firstChild)
  const link = doc.createElement('link')
  link.rel = 'stylesheet'
  link.href = `${baseUrl}quill_2.0.3.core.css`
  doc.head.appendChild(link)
  doc.body.innerHTML=cont
},createObjectURL=file=>window.URL.createObjectURL(file)
onMounted(()=>{
  window.addEventListener('resize',fitInqheight)
  searchMyApi()
  searchMemo()
  post('rest/authed/member/searchlog',{page:1,size:10,isasc:false,sortcol:'mdt'},res=>{
    let logtxt=''
    res.data.rows.forEach(log=>{
      if(log.logmsg)logtxt+=`${ymdhm(log.mdt)} ${log.logmsg}\r\n`
      else logtxt+=`${ymdhm(log.mdt)} ${log.logcate} ${log.logtype} ${log.logstatus}\r\n`
    })
    meta.logtxt=logtxt
  })
  get('rest/authed/member/cntinqueries/oneonone_inquery',res=>{
    meta.cntinqueries=res.data
  })
})
onBeforeUnmount(()=>{
  window.removeEventListener('resize', fitInqheight)
})
meta.createObjectURL=window.URL.createObjectURL;
</script>
<template>
  <MenuLayout>
    <v-card class="w-100 h-100 overflow-auto">
      <v-card-title class="font-weight-black bg-grey-lighten-4">
        <v-row>
          <v-col>
            <v-breadcrumbs :items="['mypage']">
              <template #item="{item}">{{ $t(item.title) }}</template>
            </v-breadcrumbs>
          </v-col>
          <v-col class="text-right mt-3">
            <v-btn class="me-3" variant="outlined" color="primary" :text="$t('editmemberinformation')" @click="selComponent('myinfo')"/>
            <v-btn variant="outlined" color="primary" :text="$t('logout')" @click="logout"/>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="mypagecont">
        <v-sheet v-if="!meta.component" class="ma-3">
          <v-row>
            <v-col>
              <v-card class="h-100">
                <v-card-title>
                  <v-row>
                    <v-col>{{ $t('oneonone_inquery') }}</v-col>
                    <v-col class="text-right">
                      <a href="#" class="text-subtitle-2" @click.prevent="searchInquery">{{ $t('more') }}</a>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                  <v-row no-gutters class="ma-3">
                    <v-col>{{ $t('answered') }}</v-col>
                    <v-col v-if="meta.cntinqueries" class="text-right">{{ meta.cntinqueries.donecnt }}건</v-col>
                  </v-row>
                  <v-row no-gutters class="ma-3">
                    <v-col>{{ $t('waitingforananswer') }}</v-col>
                    <v-col v-if="meta.cntinqueries" class="text-right">{{ meta.cntinqueries.notdonecnt }}건</v-col>
                  </v-row>
                  <v-btn block color="primary" style="margin-top: 60px;" :text="$t('contactus11')" @click="pop('newinquery')"/>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-if="metaStore.dispmode!='minimum'">
              <v-card class="h-100">
                <v-card-title>
                  <v-row>
                    <v-col>{{ $t('applyforanopenapikey') }}</v-col>
                    <v-col cols="2" class="pt-2 text-right"><v-btn density="compact" icon="mdi-refresh" @click="searchMyApi"/></v-col>
                  </v-row>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                  <div v-if="!meta.apikeyreq.apikey">
                    <div class="ma-5">{{ $t('openapikeyissuanceisrequired') }}</div>
                    <div class="ms-5 mb-3">{{ $t('applynow') }}</div>
                    <v-btn block color="primary" style="margin-top: 50px;" :text="$t('applyforanopenapikey')" :disabled="meta.apikeyreq.stat=='wait'" @click="reqApikey"/>
                  </div>
                  <div v-else>
                    <div class="ma-5">{{ $t('aboutopenapikeys') }}</div>
                    <div class="ms-5 mb-3 text-right apikey">{{ meta.apikeyreq.apikey }}</div>
                    <v-btn block style="margin-top: 50px;" :text="$t('copytheopenapikey')" @click="copyApikey"/>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card>
                <v-card-title>
                  {{ $t('recentactions') }}
                </v-card-title>
                <v-divider/>
                <v-card-text style="height: 200px;">
                  <textarea class="border h-100 w-100" readonly>{{ meta.logtxt }}</textarea>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-card class="mt-5">
            <v-card-title>
              {{ $t('managemynotes') }}
              <div class="d-none">
                <v-tabs color="deep-purple-accent-4" v-model="meta.seltab">
                  <v-tab v-for="tab in meta.tabs" :key="tab" :value="tab">{{ $t(tab) }}</v-tab>
                </v-tabs>
              </div>
            </v-card-title>
            <v-card-text>
              <v-tabs-window v-model="meta.seltab">
                <v-tabs-window-item v-for="tab in meta.tabs" :key="tab" :value="tab">
                  <v-row class="mt-2">
                    <v-col cols="3"><v-text-field hide-details variant="outlined" density="compact" :label="$t('enteryoursearchterm')" v-model="meta.memosearchval"/></v-col>
                    <v-col>
                      <v-btn prepend-icon="mdi-magnify" color="secondary" class="me-3" :text="$t('search')" @click="searchMemo(1)"/>
                      <v-btn :text="$t('initialize')" @click="meta.memosearchval='';searchMemo(1)"/>
                    </v-col>
                  </v-row>
                  <v-table fixed-header class="border-thin mt-2" :height="meta.memotblheight">
                    <thead>
                      <tr>
                        <th>{{ $t('registrationmodificationdate') }}</th>
                        <th>{{ $t('title') }}</th>
                        <th>{{ $t('xcoordinate') }}</th>
                        <th>{{ $t('ycoordinate') }}</th>
                        <th class="text-center">{{ $t('viewroadview') }}</th>
                        <th class="text-center">{{ $t('more') }}</th>
                        <th class="text-center">{{ $t('delete') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="memo in meta.memos">
                        <td>{{ ymd(memo.mdt) }}</td>
                        <td>{{ memo.ttl }}</td>
                        <td>{{ memo.xpos }}</td>
                        <td>{{ memo.ypos }}</td>
                        <td class="text-center"><v-btn density="compact" :text="$t('viewroadview')" @click="openWin(config.frontRoot+'member/svnew/'+memo.svid+'/'+memo.featureid)"/></td>
                        <td class="text-center"><v-btn density="compact" :text="$t('more')" @click="pop('memodetail',memo.id)"/></td>
                        <td class="text-center"><v-btn density="compact" color="error" :text="$t('delete')" @click="delMemo(memo.id)"/></td>
                      </tr>
                    </tbody>
                  </v-table>
                  <v-pagination density="compact" class="ma-auto" :length="meta.memos.pagettl" :total-visible="5" :model-value="meta.memos.currpage" @update:model-value="searchMemo"/>
                </v-tabs-window-item>
              </v-tabs-window>
            </v-card-text>
          </v-card>
        </v-sheet>
        <v-card v-if="meta.component=='inquery'" flat>
          <v-card-title>
            <v-row>
              <v-col>{{ $t('11inquiryhistory') }}</v-col>
              <v-col v-if="!meta.selinquery" class="text-right">
                <v-btn :text="$t('refresh')" @click="searchInquery" class="me-2"/>
                <v-btn color="primary" :text="$t('newregistration')" @click="pop('newinquery')"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-if="!meta.selinquery">
              <v-table fixed-header :height="meta.inqheight">
                <thead>
                  <tr>
                    <th v-for="ih in meta.inqueryheads">{{ $t(ih.tk) }}</th>
                    <th style="width: 130px;" class="text-center">{{ $t('viewdetails') }}</th>
                    <th style="width: 90px;" class="text-center">{{ $t('delete') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="meta.inqueries.rows.length==0">
                    <td :colspan="meta.inqueryheads.length+2" class="text-center">
                      {{ $t('therearecurrentlynoinquiries') }}
                    </td>
                  </tr>
                  <tr v-else v-for="row in meta.inqueries.rows">
                    <td v-for="ih in meta.inqueryheads">
                      <div v-if="ih.col=='cdt'">{{ ymd(row[ih.col]) }}</div>
                      <div v-else-if="ih.col=='stat'">
                        <div v-if="row[ih.col]=='wait'">{{ $t('waitingforananswer') }}</div>
                        <div v-else>{{ $t(row[ih.col]) }}</div>
                      </div>
                      <div v-else>{{ row[ih.col] }}</div>
                    </td>
                    <td><v-btn :text="$t('viewdetails')" @click="inqueryDetail(row)"/></td>
                    <td><v-btn color="error" :text="$t('delete')" @click="delInquery(row.id)"/></td>
                  </tr>
                </tbody>
              </v-table>
              <v-pagination v-if="meta.inqueries.rows.length>0" :length="meta.inqueries.totalPages" :total-visible="meta.inqueries.pageCount" v-model="meta.sinq.page" @update:model-value="searchInquery"/>
              <v-btn class="ma-2 btntomypage" :text="$t('tomypage')" @click="selComponent()"/>
            </div>
            <div v-else>
              <v-table class="inquerytbl" style="border: 1px solid #e0e0e0;">
                <tbody>
                  <tr v-for="inp in ['title','contents','fileattachments','answer']">
                    <th class="bg-grey-lighten-4 text-center" style="width: 100px;">{{ $t(inp) }}</th>
                    <td>
                      <div v-if="inp=='title'">{{ meta.selinquery.ttl }}</div>
                      <div v-else-if="inp=='fileattachments'">
                        <div v-if="meta.selinquery.fid">
                          <img v-if="meta.selinquery.imgdata" :src="meta.selinquery.imgdata" style="max-width: 100%;max-height: calc(100vh - 500px);" class="mt-2"/>
                          <div>
                             <v-btn class="mt-2 mb-2" @click="down({url:meta.selinquery.furl,method:'get'})">
                              <FileIcons :name="meta.selinquery.fn"/>
                              {{ $t('download') }}
                             </v-btn>
                          </div>
                        </div>
                      </div>
                      <div v-else class="pt-3 pb-3">
                        <!-- <iframe class="conifr" :src="baseUrl+'blank.html'" @load="setIfrCont($event.target,inp=='contents'?meta.selinquery.cont:meta.selinquery.reply)"
                          style="border-width: 0;width: 100%;min-height: 300px;"></iframe> -->
                          <div class="inquerycontquill ">
                            <QuillEditor theme="snow" class="w-100" content-type="html" :content="inp=='contents'?meta.selinquery.cont:meta.selinquery.reply" @ready="evt=>{
                              qsela('.inquerycontquill .ql-toolbar').forEach(el=>el.remove())
                              qsela('.inquerycontquill .ql-editor').forEach(el=>el.contentEditable=false)
                              qsela('.inquerycontquill .ql-container').forEach(el=>el.style.borderWidth=0)
                            }"/>
                          </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <div class="text-right">
                <v-btn class="ma-2 btntomypage" :text="$t('tomypage')" @click="selComponent()"/>
                <v-btn class="ma-2" :text="$t('tolist')" @click="selComponent('inquery')"/>
              </div>
            </div>
          </v-card-text>
        </v-card>
        <v-sheet v-if="meta.component=='myinfo'">
          <v-card flat>
            <v-card-title>
              <v-row class="ma-2">
                <v-col>{{ $t('editmemberinformation') }}</v-col>
                <v-col class="text-right"><v-btn color="primary" :text="$t('saveinfo')" width="170px" :disabled="_.isEmpty(meta.myinfo.mname)"
                  @click="meta.confirmttlkey='editmemberinformation';pop('savemyinfo')"/></v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact',noGutters:true}}">
                <v-table class="myinfomodtbl ma-2">
                  <tbody>
                    <tr>
                      <th>{{ $t('id') }}</th>
                      <td colspan="3">{{ meta.myinfo.mid }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('email') }}</th>
                      <td colspan="3">
                        <v-row>
                          <v-col>{{ meta.myinfo.email }}</v-col>
                          <v-col cols="2"><v-btn :text="$t('changeyouremail')" @click="pop('changeyouremail')"/></v-col>
                        </v-row>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('name') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.myinfo.mname"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('contact') }}</th>
                      <td><v-text-field v-model="meta.myinfo.contact" @keyup="evt=>meta.myinfo.contact = evt.target.value.replace(/[^\d-]/g, '')"/></td>
                      <th>{{ $t('companyperiodname') }}</th>
                      <td><v-text-field v-model="meta.myinfo.company"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('departmentname') }}</th>
                      <td><v-text-field v-model="meta.myinfo.dept"/></td>
                      <th>{{ $t('jobtitle') }}</th>
                      <td><v-text-field v-model="meta.myinfo.jobtitle"/></td>
                    </tr>
                  </tbody>
                </v-table>
              </v-defaults-provider>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-title>
              <v-row class="ma-2">
                <v-col>{{ $t('changeyourpassword') }}</v-col>
                <v-col class="text-right"><v-btn color="primary" :text="$t('changeyourpassword')" width="170px"
                  :disabled="_.isEmpty(meta.myinfo.temppasswd)||isValidPassword(meta.myinfo.passwd)!==true||_.isEmpty(meta.myinfo.passwd)||meta.myinfo.passwd!=meta.myinfo.passwdcon"
                  @click="meta.confirmttlkey='changeyourpassword';pop('savemyinfo')"/></v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact',noGutters:true}}">
                <v-table class="myinfomodtbl ma-2">
                  <tbody>
                    <tr>
                      <th>{{ $t('currentpassword') }}</th>
                      <td><v-text-field type="password" :placeholder="$t('pleaseenteryourpassword')" v-model="meta.myinfo.temppasswd"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('newpassword') }}</th>
                      <td><v-text-field type="password" :placeholder="$t('pleaseenteryourpassword')" class="mt-3" :hide-details="false" :rules="[isValidPassword]" v-model="meta.myinfo.passwd"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('confirmpassword') }}</th>
                      <td><v-text-field type="password" :placeholder="$t('pleaseconfirmyourpassword')" class="mt-3" :hide-details="false" :rules="[pw=>{
                        if(meta.myinfo.passwd==pw)return true
                        else return '새로운 비밀번호와 동일하지 않습니다.'
                      }]" v-model="meta.myinfo.passwdcon"/></td>
                    </tr>
                  </tbody>
                </v-table>
              </v-defaults-provider>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-title>
              <v-row class="ma-2">
                <v-col>{{ $t('marketingconsent') }}</v-col>
                <v-col class="text-right"><v-btn color="primary" :text="$t('marketingconsent')+' '+$t('save')"  @click="meta.confirmttlkey='marketingconsent';pop('savemyinfo')"/></v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact',noGutters:true}}">
                <v-table class="myinfomodtbl ma-2">
                  <tbody>
                    <tr>
                      <th>{{ $t('email') }}</th>
                      <td><v-checkbox :label="$t('email')" v-model="meta.myinfo.agreedemailads"/></td>
                      <th>{{ $t('optin') }}</th>
                      <td>{{ ymdhm(meta.myinfo.agreedemailadsdt) }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('alerttalktext') }}</th>
                      <td style="width: 40%;"><v-checkbox :label="$t('alerttalktext')" v-model="meta.myinfo.agreedsnssmsads"/></td>
                      <th>{{ $t('optin') }}</th>
                      <td>{{ ymdhm(meta.myinfo.agreedsnssmsadsdt) }}</td>
                    </tr>
                  </tbody>
                </v-table>
              </v-defaults-provider>
            </v-card-text>
          </v-card>
          <v-row class="ma-1">
            <v-col><p class="cursor-pointer text-decoration-underline" @click.stop="pop('withdrawal')">{{ $t('withdrawal') }}</p></v-col>
            <v-col class="text-right"><v-btn variant="elevated" class="btntomypage" :text="$t('tomypage')" width="150px" @click="selComponent()"/></v-col>
          </v-row>
        </v-sheet>
      </v-card-text>
    </v-card>
  </MenuLayout>
  <Teleport v-if="meta.poptype=='newinquery'" to="#popbody">
    <v-card min-width="400" max-height="calc(100vh - 50px)">
      <v-card-title class="text-center">{{`${$t('inquiries')} ${$t('newregistration')}`}}</v-card-title>
      <v-divider/>
      <v-card-text style="overflow-y: auto;max-height: calc(100vh - 150px);">
        <v-table>
          <tbody>
            <tr v-for="inp in ['title','contents','fileattachments']">
              <th class="bg-grey-lighten-4 text-center" style="width: 100px;">{{ $t(inp) }}</th>
              <td>
                <v-text-field v-if="inp=='title'" variant="outlined" density="compact" class="mt-3" :rules="[validators.required]" v-model="meta.pdinq.ttl"/>
                <div v-else-if="inp=='contents'" class="pt-3 pb-3">
                  <QuillEditor theme="snow" class="inqueryquill w-100" content-type="html" @update:content="cont=>meta.pdinq.cont=cont"/>
                  <div v-if="_.isEmpty(meta.pdinq.cont)" class="v-input__details">
                    <div class="v-messages" style="color:rgb(var(--v-theme-error));opacity: 1;">{{ $t('pleaseconfirmtheinformationyouentered') }}</div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="meta.pdinq.file" class="pa-2 text-center">
                    <img v-if="isImage(meta.pdinq.file.name)" :src="meta.createObjectURL(meta.pdinq.file)" class="w-100 h-100" style="max-width: 300px;max-height: 300px;"/>
                  </div>
                  <v-file-input show-size hide-details variant="outlined" density="compact" class="mt-3 inqfile" :label="$t(inp)" v-model="meta.pdinq.file" @update:model-value="inqFileChange"/>
                  <div>이미지 첨부 5MB이내 / jpg, png, bmp, gif 만 가능</div>
                  <div>※ 내용 본문과 첨부된 파일, 이미지에 고객님의 개인정보(계좌, 카드, 주민번호 등)가 포함되지 않도록 주의해주세요</div>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn :text="$t('cancel')" variant="elevated" @click="pop"/>
        <v-btn :text="$t('save')" variant="elevated" color="primary" :disabled="_.isEmpty(meta.pdinq.ttl)||_.isEmpty(meta.pdinq.cont)" @click="newInquery"/>
      </v-card-actions>
    </v-card>
  </Teleport>
  <Teleport v-if="meta.poptype=='savemyinfo'" to="#popbody">
    <ConfirmCard :ttl="$t(meta.confirmttlkey)" cont="save" @cancel="pop()" @confirm="saveMyInfo"/>
  </Teleport>
  <Teleport v-if="meta.poptype=='withdrawal'" to="#popbody">
    <v-card class="mx-auto" width="400" :title="$t('withdrawal')">
      <v-divider/>
      <v-card-text class="pa-8">
        <h2 class="mb-2">주의하세요!</h2>
        <p>탈퇴시 삭제/유지되는 정보를 확인하세요</p>
        <p>한번 삭제된 정보는 복구가 불가능합니다.</p>
        <ul class="ma-4">
          <li>계정정보 삭제</li>
          <li>문의내역 삭제</li>
          <li>나의 메모 삭제</li>
        </ul>
        <p>{{ $t('enteryourcurrentpassword') }}</p>
        <v-text-field type="password" variant="outlined" density="compact" :placeholder="$t('enteryourpassword')" v-model="meta.myinfo.passwdforwithdrawal"/>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-row justify="end">
          <v-btn :text="$t('cancel')" variant="outlined" @click.stop="pop()"/>
          <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="withdraw"/>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
  <Teleport v-if="meta.poptype&&meta.poptype.startsWith('changeyouremail')" to="#popbody">
    <v-card class="mx-auto" width="400" :title="$t('changeyouremail')">
      <v-divider/>
      <v-card-text class="pa-8">
        <p>{{ $t('entertheemailaddressyoudliketochange') }}</p>
        <v-row no-gutters>
          <v-col>
            <v-text-field variant="outlined" density="compact" :placeholder="$t('pleaseenteryouremailaddress')" v-model="meta.emailtochange" :rules="[validators.email]" :disabled="meta.poptype.endsWith('_sent')"/>
          </v-col>
          <v-col v-if="!meta.poptype.endsWith('_sent')" cols="4"><v-btn style="margin: 2px 0 0 5px;" :text="$t('sendanauthorizationnumber')"
            :disabled="validators.email(meta.emailtochange)!==true" @click="sendCode"/></v-col>
        </v-row>
        <div v-if="meta.poptype.endsWith('_sent')">
          <p>{{ $t('enteryourverificationnumber') }}</p>
          <v-row>
            <v-col>
              <v-text-field variant="outlined" density="compact" :placeholder="$t('pleaseenteryourverificationnumber')" v-model="meta.verificationnumber"/>
            </v-col>
            <v-col cols="3"><v-btn style="margin: 2px 0 0 5px;" :text="$t('resend')" @click="sendCode"/></v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-row justify="end">
          <v-btn :text="$t('cancel')" variant="outlined" @click.stop="pop()"/>
          <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" :disabled="_.isEmpty(meta.verificationnumber)" @click.stop="changeEmail"/>
        </v-row>
      </v-card-actions>
      <v-overlay :model-value="meta.poptype=='changeyouremail_loading'" class="align-center justify-center" :persistent="true">
        <v-progress-circular color="primary" size="64" indeterminate/>
      </v-overlay>
    </v-card>
  </Teleport>
  <Teleport v-if="meta.poptype=='memodetail'" to="#popbody">
    <v-card width="400" class="memodetail">
      <v-card-title>
        <v-row>
          <v-col>메모 보기 / 수정</v-col>
          <v-col class="text-right">
            <v-btn density="compact" icon="mdi-close" @click="pop()"/>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-text-field class="mb-3" hide-details variant="outlined" density="compact" :label="$t('title')" v-model="meta.selmemo.ttl"/>
        <v-textarea class="mb-3" hide-details variant="outlined" density="compact" :label="$t('contents')" v-model="meta.selmemo.cont"/>
        <v-row class="mb-3">
          <v-col><v-text-field hide-details variant="outlined" density="compact" readonly :label="$t('xcoordinate')" v-model="meta.selmemo.xpos"/></v-col>
          <v-col><v-text-field hide-details variant="outlined" density="compact" readonly :label="$t('ycoordinate')" v-model="meta.selmemo.ypos"/></v-col>
        </v-row>
        <v-text-field class="mb-3" hide-details variant="outlined" density="compact" readonly :label="$t('addressinformation')" v-model="meta.selmemo.addr"/>
        <p style="margin-bottom: 20px;">{{ $t('img') }}</p>
        <div class="d-none memoimgwrap" style="display: inline-block;position: relative;border: 1px solid black;">
          <img class="memoimg" style="max-width: 100%;max-height: 300px;"/>
          <img class="memoimgdel" :src="config.frontRoot+'close_circle.png'" width="32" style="position: absolute;top: -16px;right: -16px;cursor: pointer;" @click="delMemoImg"/>
        </div>
        <v-file-input show-size hide-details variant="outlined" density="compact" class="mt-3" v-model="meta.selmemo.file" @update:model-value="file=>{
          const wrap=qsel('.memodetail .memoimgwrap')
          const img=qsel('.memodetail .memoimg')
          if(file){
            img.src=createObjectURL(file)
            wrap.classList.remove('d-none')
          }else wrap.classList.add('d-none')
        }"/>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col><v-btn block variant="elevated" color="error" :text="$t('cancel')" @click="pop()"/></v-col>
          <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="saveMemo()"/></v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
<style>
.inqueryquill {height: 300px;}
.inqueryquill .ql-editor{height: 100%;}
.myinfomodtbl table{border: 1px solid #e0e0e0;}
.myinfomodtbl th{background-color: #eee;text-align: center !important;width: 200px;}
.myinfomodtbl tr{height: 60px;}
.v-number-input__control{display: none;}
</style>
